import { BaseNodeCommand, NodeChangeRecord } from '../../../core/commands/base/BaseNodeCommand';

export class UpdatePersonCommand extends BaseNodeCommand {
  private personId: string;
  private updates: any;
  
  constructor(personId: string, updates: any) {
    const updateKeys = Object.keys(updates).join(', ');
    super('Update Person', `Update ${updateKeys}`);
    this.personId = personId;
    this.updates = updates;
  }
  
  protected doExecute(): NodeChangeRecord[] {
    const record = this.getMutationManager().applyNodeChange(this.personId, this.updates);
    return record ? [record] : [];
  }
}